import React from 'react';

import { ColumntLayoutProps } from '../ContentSection';

import './three-columns-layout.scss';

export const ThreeColumnsLayout: React.FC<ColumntLayoutProps> = ({ content, renderWidget }) => (
  <div className="student-three-columns-layout">
    <div className="student-three-columns-layout__column student-column">{renderWidget(content.columns[0].widget)}</div>
    <div className="student-three-columns-layout__column student-column">{renderWidget(content.columns[1].widget)}</div>
    <div className="student-three-columns-layout__column student-column">{renderWidget(content.columns[2].widget)}</div>
  </div>
);
